<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "FAQs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "FAQs",
            items: [
               {
                  text: "FAQs",
                  active: true,
               },                   
            ],

            faqs: [],
            faq: {
               id: null,
               question : "",
               answer: "",
            },
            
            modal_title: "Add FAQ",
            button_title: "Save",
            pagination: {},
            edit: false,
            faq_status: {
               id: "",
               status: "",
            },
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editFAQ() {            
            this.modal_title = "Edit FAQ";
            this.button_title = "Update";
            this.faq.question = "Lorem ipsum dolor sit amet?"; 
            this.faq.answer = "Donec dignissim dolor id sapien mollis elementum. Nullam quam risus, commodo id orci eu, varius interdum tellus. In magna elit, interdum rutrum orci vel, euismod hendrerit arcu. In diam libero, semper non eros eu, euismod dapibus libero. Suspendisse venenatis felis vel libero pulvinar, pellentesque malesuada diam dictum. Mauris id eros risus.";  
            this.edit = true;
            this.showModal("faq-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add FAQ";
            this.button_title = "Save";
            this.faq.question = "";           
            this.faq.answer = "";           
            this.edit = false;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.faq-modal variant="primary" class="float-end">Add FAQ</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                     
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="20%">Question</th> 
                              <th width="30%">Answer</th>   
                              <th width="20%">Created On</th>
                              <th width="15%">Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>Lorem ipsum dolor sit amet?</td>
                              <td>Donec dapibus orci turpis. Praesent vitae lacus ligula... </td>
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editFAQ">Edit</b-button>

                                 <b-button variant="danger" class="btn btn-sm me-2 mb-2" >Unpublish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="faq-modal" id="faq-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form>                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Question<span class="text-danger">*</span></label>
                           <b-form-input v-model="faq.question"></b-form-input>
                        </b-col>

                        <b-col md="12" class="form-group">
                           <label class="control-label">Answer<span class="text-danger">*</span></label>
                           <textarea class="form-control" rows="5" v-model="faq.answer"></textarea>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('faq-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
